import { useState, useEffect } from "react";

import useSKU from "../../hooks/useSKU";
import useLocalization from "../../hooks/useLocalization";

import { Box, Stack, Typography } from "@mui/material";

const SkuMatrixDisplay = ({ skuMatrix }) => {
  const { getMessage } = useLocalization();
  const { getSkus } = useSKU();

  const [skus, setSkus] = useState([]);

  useEffect(() => {
    console.log({ skuMatrix });
    getData();
  }, [skuMatrix]);

  const getData = async () => {
    const items = Array.isArray(skuMatrix?.items) ? skuMatrix.items : [];
    const ids = items
      .map((sku) => (typeof sku === "string" ? sku : sku.skuId || sku.id))
      .filter(Boolean);

    console.log("ids: ", ids);

    if (ids.length > 0) {
      const skuList = await getSkus({ id: { $in: ids } });

      console.log("skuList: ", skuList);
      setSkus(Array.isArray(skuList) ? skuList : []);
      return;
    }

    setSkus([]);
  };

  return (
    <Box>
      {Array.isArray(skus) && skus.length > 0 ? (
        <Stack spcing={1}>
          {skus.map((sku) => (
            <Box>
              <Typography style={styles.text}>{sku.name}</Typography>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography style={styles.text}>{getMessage("notSet")}</Typography>
      )}
    </Box>
  );
};

const styles = {
  text: {
    fontSize: "10px",
  },
};

export default SkuMatrixDisplay;
